import { Component, Watch } from 'vue-property-decorator'

import { Location } from '@skinsoft/types'
import { locationSelectors } from '@skinsoft/selectors'
import { LocationDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'

@Component({
    props: ['id'],
    template: require('./location-name.html'),
})
export class LocationName extends ReactiveVue {
    get value() {
        return locationSelectors.translatedTitle(this.location, this.getAppLocale());
    }

    public id: string;
    public $locationDataStore: LocationDataStore;
    public location: Location = null as any;

    private subscribeToLocation() {
        this.subscribeTo(
            this.$locationDataStore.fetchOne(this.id),
            location => {
                this.location = location;
            },
            'location',
        );
    }

    @Watch('id', { immediate: true })
    private onIdChange(id: string) {
        this.unsubscribeFrom('location');
        if (id) {
            this.subscribeToLocation();
        }
    }
}
